module.exports = __webpack_public_path__ + "img/dfm.5d83ab96.svg";